export const GRID_PAGE_SIZE = 1000;

export const FAVOURITES_ORDER_DOC_ID = 'favouritesOrder';

export const DASHBOARDS_COLLECTION = 'dashboards-v2';

export const REPORTS_COLLECTION = 'reports-v2';

export const WALLBOARDS_COLLECTION = 'wallBoards';

export const BOARDS_COLLECTION = 'boards';

export const WORKSPACES_COLLECTION = 'workSpaces';

export const CANVAS_VERTICAL_SNAPPING_POINTS = 20;

export const CANVAS_ID = 'canvas';

export const EXCLUDE_HEIGHT = 'exclude-height';

export const MODAL_MARGIN = 60;

export const SCORECARDS_COLLECTION = 'scorecards-v2';

export const CURRENT_SCORECARD_VERSION = '3' as '3';

export const WORKSPACE_RESOURCE = 'WorkSpace' as 'WorkSpace';

export const SCORECARD_RESOURCE = 'Scorecard' as 'Scorecard';

export const PORTAL_RESOURCE = 'Portal' as 'Portal';

export const APP_RESOURCE = 'App' as 'App';

/**
 * Yes, "DatasetFilter" is intentional here
 * Feel free to write a migration which changes this over
 */
export const SAVED_FILTER_RESOURCE = 'DatasetFilter' as 'DatasetFilter';

export const GOAL_RESOURCE = 'Goal' as 'Goal';

export const WESTSIDE_ACCOUNT_ID = 'lzpIhynATYgKXiyA';

export const WAYNE_TRANSPORT_ACCOUNT_ID = 'sWptCNfOdoztCktzmLzDxpDN';

export const NATIONAL_CARRIERS_ACCOUNT_ID = 'KFiymixJlAlYVHyksyrVIBeO';

export const NAVAJO_ACCOUNT_ID = 'gATHOfPMQhpoxHBp';

export const STAGING_ACCOUNT_DCI_ID = 'demonci';
export const STAGING_ACCOUNT_GOGGINS_ID = 'HpxgsPKInM80U4L0KjAX';
export const STAGING_ACCOUNT_ID = 'qMGLJLdLmNlgmBtNgQuRBvVS';

/**
 * These are for the legacy bonus system at Navajo and NCI
 */
export const DRIVER_BONUS_DATA_SETS = [
  'driverScoreMonth',
  'driverScoreQuarter',
];

export const TOP_BAR_HEIGHT = 54;

export const TABS_TOP_BAR_HEIGHT = TOP_BAR_HEIGHT;

export const SLIDE_OUT_ELEMENT_ID = 'fleetops-slide-out';

// The Insights chat docks alongside content (not as an overlay), so it portals
// into this target — a sized flex child of the layout body — rather than the
// shared body-level SLIDE_OUT target.
export const INSIGHTS_DOCK_ELEMENT_ID = 'fleetops-insights-dock';
// Set on <body> while the Insights "pick a value to explain" mode is armed, so
// the global stylesheet can switch chart points and grid cells to a crosshair.
export const INSIGHTS_EXPLAIN_PICKER_BODY_CLASS =
  'insights-explain-picker-armed';

export const FADE_IN_ELEMENT_ID = 'fleetops-fade-in';

export const Z_INDEX = {
  SLIDE_OUT_OVERLAY_CLOSED: -100,
  SIDE_NAV_TOGGLE: 1,
  SCORECARD_COLUMN_HEADING: 1,
  GRID_SLIDE_OUT: 1,
  GENERAL_BOARD_SLIDE_OUT: 1,
  CUSTOMER_LANE_CONFIG_SLIDEOUT: 1,
  SCORECARD_KPIS: 2,
  GADGET_TOP_BAR: 4,
  TABS_ROW: 9,
  WORKSPACE_DASHBOARD_MENU: 10,
  SCORECARD_SHADOWS: 10,
  SEARCH_OVERLAY_BUTTONS: 10,
  SLIDE_OUT_OVERLAY_OPENED: 12,
  SLIDE_OUT: 13,
  WALLBOARD_PREVIEW_DASHBOARD: 10,
  TEXT_GADGET: 100,
  CHART: 300,
  // Studio's gadget settings floating over the canvas: above its charts
  STUDIO_FLOATING_SETTINGS: 400,
  // Studio's collapsed library, opened over the canvas while hovered
  STUDIO_FLOATING_LIBRARY: 400,
  // Above the app's chrome, below dialogs and tooltips raised from inside it
  STUDIO_FULLSCREEN: 5000,
  // Studio's tour: its spotlight and coachmark, over a fullscreen gadget
  STUDIO_GUIDE_TOUR: 5100,
  VIEWING_APP_AS: 9999,
  INLINE_DIALOG: 10000,
  DRAG_DROP: 10001,
  TOAST: 10002,
  TOOLTIP: 10003,
  CONFIGURE_DASHBOARD_GADGET: 1000000,
  CANVAS_CARD_FOOTER: 1000001,
  CANVAS_CARD_RESIZE_HANDLE: 1000002,
};

export const DEFAULT_FORMATTING = {} as MetricFormatting;

export const CUSTOMER_LANE_COMMITMENTS = 'customerLaneCommitments';

export const TARGET_PERFORMANCE_APP = 'targetsApp';

export const GQL_ERROR = 'GQL Error';

export const LOCAL_STORAGE_IMPERSONATING_USER_ID = 'impersonating-user-id';

export const ENTITY_APP_SIDEBAR_DROPDOWN_DIV_ID =
  'ENTITY_APP_SIDEBAR_DROPDOWN_DIV_ID';

export const QUALIFIES_FOR_BONUS_FIELD = 'qualifiesForBonus';

export const FISCAL_PERIODS_DISABLED_TOOLTIP =
  'Fiscal periods are not enabled, please contact us to enable this feature';
